import React, { useEffect, useState } from "react";
import ItemInfoInputPanelView from "presentational/search/ItemInfoInputPanelView";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { withStore } from "store/storeHandler";
import { isSameObject, removeUndefinedFromObject } from "lib/commonUtil";
import {
  getFullUrl,
  getQueryObjFromUrl,
  getEssentialUrl
} from "lib/urlQueryParser";

SearchActionGroup.propTypes = {
  getNewList: PropTypes.func.isRequired,
  category: PropTypes.string,
  tag: PropTypes.string,
  color: PropTypes.string,
  brand: PropTypes.string,
  gender: PropTypes.string,
  clearSearchList: PropTypes.func.isRequired
};

function SearchActionGroup(props) {
  const {
    getNewList,
    category,
    tag,
    color,
    brand,
    gender,
    clearSearchList,
    myProfile
  } = props;
  const [nextQueryObj, setNextQueryObj] = useState({
    category: undefined,
    brand: undefined,
    color: undefined,
    tag: undefined,
    gender: undefined
  });
  const [readyToSubmit, setReadyToSubmit] = useState(false);

  const history = useHistory();

  useEffect(() => {
    initNextQueryObj();
  }, []);
  useEffect(() => {
    if (readyToSubmit) {
      sendQryToParent();
      setReadyToSubmit(false);
    }
  }, [readyToSubmit]);

  const initNextQueryObj = async () => {
    const initQry = {
      category: category || undefined,
      tag: tag || undefined,
      color: color || undefined,
      brand: brand || undefined,
      gender: gender || myProfile.gender
    };
    setNextQueryObj(removeUndefinedFromObject(initQry));
    handleSubmit();
  };

  const handleSubmit = () => {
    setReadyToSubmit(true);
  };

  const alreadyPageLoaded = () => {
    const nowQueryObj = getQueryObjFromUrl(history.location.search);
    return isSameObject(nextQueryObj, nowQueryObj);
  };

  const sendQryToParent = () => {
    const { category, gender } = nextQueryObj;

    if (!category || !gender) return null;

    getNewList(nextQueryObj);

    if (alreadyPageLoaded()) return null;
    const nextUrl = getFullUrl({
      url: getEssentialUrl({ type: "search" })(),
      queryObj: nextQueryObj
    });
    history.replace(nextUrl);
  };

  const handleInfoChange = async (type, value) => {
    const newNextQueryObj = { ...nextQueryObj };

    if (type === "brand" || type === "color" || type === "tag") {
      newNextQueryObj.brand = undefined;
      newNextQueryObj.color = undefined;
      newNextQueryObj.tag = undefined;
    }
    newNextQueryObj[type] = value;

    setNextQueryObj(removeUndefinedFromObject(newNextQueryObj));
  };

  const handleOptionResetBtnClick = () => {
    clearSearchList();
    history.replace(getEssentialUrl({ type: "search" })());
  };

  return (
    <ItemInfoInputPanelView
      nextQueryObj={nextQueryObj}
      onChange={handleInfoChange}
      onSubmit={handleSubmit}
      onOptionResetBtnClick={handleOptionResetBtnClick}
    />
  );
}

export default withStore({
  stateMap: {
    userProfile: ["myProfile"]
  }
})(SearchActionGroup);
